import { render, staticRenderFns } from "./DrawerPhoneForm.vue?vue&type=template&id=dca3bb88&scoped=true"
import script from "./DrawerPhoneForm.vue?vue&type=script&lang=js"
export * from "./DrawerPhoneForm.vue?vue&type=script&lang=js"
import style0 from "./DrawerPhoneForm.vue?vue&type=style&index=0&id=dca3bb88&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dca3bb88",
  null
  
)

export default component.exports